import { Task } from 'interfaces/entities/task.model'
import { toDate } from 'helpers/dateHelper'
import { MenuItem, Select, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Controller, useFormContext } from 'react-hook-form'

interface TaskMainInfoProps {
    task: Task
    members: any[]
}

export const TaskMainInfo = ({ task, members }: TaskMainInfoProps) => {
    const { t } = useTranslation()
    const { control, register, setValue, watch, getValues } = useFormContext();
    return (
        <section>
            <div className="flex flex-col gap-4">
                {task?.createdAt && (
                    <div className="flex gap-2 items-center">
                        <span className="flex-[0.3]">Создана</span>
                        <span className="flex-[0.7]">{toDate(task.createdAt)}</span>
                    </div>
                )}
                <div className="flex gap-2 items-center">
                    <span className="flex-[0.3]">Ответственный</span>
                    <span className="flex-[0.7]"><Controller control={control} name="assigneeID" render={({ field }) => (
                        <Select {...field}>
                            {members?.map((member: any) => (
                                <MenuItem key={member.id} value={member.id}>{member.name || member.userID}</MenuItem>
                            ))}
                        </Select>
                    )} /></span>
                </div>
                <div className="flex gap-2 items-center">
                    <span className="flex-[0.3]">Приоритет</span>
                    <span className="flex-[0.7]">Средний</span>
                </div>
                <div className="flex gap-2 items-center">
                    <span className="flex-[0.3]">Дата окончания</span>
                    <span className="flex-[0.7]"><Controller control={control} name="dueDate" render={({ field }) => (
                        <TextField type="date" {...field} InputLabelProps={{ shrink: true }} />
                    )} /></span>
                </div>
                {/* Связенные сделки */}
                <div className='flex gap-2 items-center'>
                    <span className="flex-[0.3]">Связенные сделки</span>
                    <span className="flex-[0.7] text-blue-500">{task?.lead ? <div>{task.lead.name}</div> : '-'}</span>
                </div>
            </div>
            <div className="flex flex-col gap-2 mt-4">
                <div>Описание</div>
                <TextField
                    {...register('description')}
                    multiline
                    rows={4}
                    fullWidth
                    className="mt-2"
                />
            </div>
        </section>
    )
}
